import { useMarkdownStyle } from "../../components/markdown/MarkdownStyleContext";
import { sameNodePosition, } from "../../components/markdown/utils";
import React, { memo } from "react";
/**
 * Renders bold (`**strong**`) text inside Markdown output with semibold
 * weight and the context text color.
 * @summary Strong-text renderer for Markdown.
 */
export const StrongBlock = memo(function StrongBlock({ children }) {
    const { textColor } = useMarkdownStyle();
    return React.createElement("strong", { className: `font-semibold ${textColor}` }, children);
}, (prev, next) => sameNodePosition(prev.node, next.node));
//# sourceMappingURL=StrongBlock.js.map